function researchBriefs() {
    document.querySelectorAll('[data-type=ResearchBriefs]').forEach(comp => {
        const filters = comp.querySelector('.filters')
        const posts = [...comp.querySelectorAll('.post-item')]
    
        // Category Variables
        let categoryGroups = [...filters.querySelectorAll('li.filter-group')]
    
        // Tag Variables
        const tagFilter = filters.querySelector('#tag-filter')
        const tagSearch = tagFilter.querySelector('input')
        const tagWrap = tagFilter.querySelector('.tag-wrap')
        const activeTags = filters.querySelector('.active-tags')
    
        // Search Variables
        const searchField = filters.querySelector('#keyword-search input')
        const searchLoading = filters.querySelector('#keyword-search svg.loading')
        const searchedPosts = []
        let searchDelay
    
        // Clear Filters
        const clearFiltersRow = comp.querySelector('#clear-filters')
        const clearFiltersButton = clearFiltersRow.querySelector('span[role=button]')
    
        const postIsSearchedFor = post => {
            if (searchedPosts.length === 0) {
                return true
            }
            return searchedPosts.includes(parseInt(post.dataset.id))
        }
    
        const checkIfNoneFound = _ => {
            const noneFound = comp.querySelector('#none-found')
            if (noneFound) {
                if (comp.querySelectorAll('.post-item:not(.d-none)').length === 0) {
                    noneFound.classList.remove('d-none')
                } else {
                    noneFound.classList.add('d-none')
                }
            }
        }

        const initFiltersFromUrl = _ => {
            const urlParams = new URLSearchParams(window.location.search);
            const activeFilters = categoryGroups.map(group => {
                const find = [...group.querySelectorAll('li')]
                    .find(item => item.dataset.value === urlParams.get(item.dataset.tax))
                if (find) {
                    find.dataset.active = 1
                    find.classList.add('ticked')
                }
                return find && (isNaN(parseInt(find.dataset.value)) ? find.dataset.value : parseInt(find.dataset.value))
            }).filter(e => e);

            if (urlParams.has('tag')) {
                const tags = urlParams.getAll('tag');
                tags.forEach(tag => {
                    const find = [...tagWrap.querySelectorAll('li')]
                        .find(item => item.dataset.value === tag)
                    if (find) {
                        const span = document.createElement('span')
                        span.classList.add('bg-primary', 'text-white', 'p-2', 'text-sm', 'active-tag', 'rounded-lg', 'overflow-hidden')
                        span.appendChild(document.createTextNode(find.innerText))
                        span.dataset.value = find.dataset.value
                        const btn = document.createElement('span')
                        btn.classList.add('ml-2', 'cursor-pointer')
                        btn.appendChild(document.createTextNode('\u00d7'))
                        btn.addEventListener('click', _ => {
                            activeTags.removeChild(span)
                            find.classList.remove('active')
                            updateFilters()
                        })
                        span.appendChild(btn)
                        activeTags.appendChild(span)
                        activeFilters.push(parseInt(find.dataset.value))
                        find.classList.add('d-none', 'active')
                    }
                })
            }

            if (activeFilters.length || searchField?.value.length > 0) {
                clearFiltersRow.classList.remove('hidden')
            }

            posts.forEach(post => {
                const domPost = document.querySelector(`#${post.id}`);
                const postCats = JSON.parse(post.dataset.cats)
                if (activeFilters.every(cat => { return postCats.includes(cat) || cat == post.dataset.country || cat == post.dataset.author }) && postIsSearchedFor(post)) {
                    domPost.classList.remove('d-none')
                    domPost.parentElement.classList.remove('d-none')
                    domPost.classList.add('d-block')
                } else {
                    domPost.classList.add('d-none')
                    domPost.parentElement.classList.add('d-none')
                    domPost.classList.remove('d-block')
                }
            })
            checkIfNoneFound();
        }

        initFiltersFromUrl();

        const updateFilters = _ => {
            categoryGroups = [...filters.querySelectorAll('li.filter-group')]
            window.history.replaceState({}, '', window.location.pathname);
            const activeFilters = categoryGroups.map(group => {
                const find = [...group.querySelectorAll('li')]
                    .find(item => item.dataset.active === '1')
                if (find && find.dataset.tax) {
                    const urlParams = new URLSearchParams(window.location.search);
                    urlParams.set(find.dataset.tax, find.dataset.value);
                    window.history.replaceState({}, '', `${window.location.pathname}?${urlParams}`);
                }
                return find && (isNaN(parseInt(find.dataset.value)) ? find.dataset.value : parseInt(find.dataset.value))
            }).filter(e => e);
    
            activeFilters.push(...[...activeTags.querySelectorAll('.active-tag')].map(tag => {
                const urlParams = new URLSearchParams(window.location.search);
                const tagValue = parseInt(tag.dataset.value);
                if (!urlParams.has('tag')) {
                    urlParams.append('tag', tagValue);
                } else {
                    const tags = urlParams.getAll('tag');
                    if (!tags.includes(tagValue.toString())) {
                        urlParams.append('tag', tagValue);
                    }
                }
                window.history.replaceState({}, '', `${window.location.pathname}?${urlParams}`);
                return tagValue;
            }));
            
            if (activeFilters.length || searchField?.value.length > 0) {
                clearFiltersRow.classList.remove('hidden')
            } else {
                clearFiltersRow.classList.add('hidden')
            }
            
            posts.forEach(post => {
                const domPost = document.querySelector(`#${post.id}`);
                const postCats = JSON.parse(post.dataset.cats)
                if (activeFilters.every(cat => { return postCats.includes(cat) || cat == post.dataset.country || cat == post.dataset.author }) && postIsSearchedFor(post)) {
                    domPost.classList.remove('d-none')
                    domPost.parentElement.classList.remove('d-none')
                    domPost.classList.add('d-block')
                } else {
                    domPost.classList.add('d-none')
                    domPost.parentElement.classList.add('d-none')
                    domPost.classList.remove('d-block')
                }
            })
            checkIfNoneFound();
        }
    
        const clearFilters = _ => {
            categoryGroups.forEach(group => {
                [...group.querySelectorAll('li')]
                    .filter(item => item.dataset.active === '1')
                    .forEach(item => {
                        item.dataset.active = 0
                    })
            })
    
            tagWrap.querySelectorAll('li.active').forEach(tag => {
                tag.classList.remove('active')
            });
            [...activeTags.children].forEach(tag => {
                activeTags.removeChild(tag)
            })
    
            if (searchField) {
                searchField.value = ''
                searchedPosts.splice(0)
            }
    
            updateFilters()
        }
    
        /**********************
         *     Categories     *
         **********************/
        categoryGroups.forEach(group => {
            const items = [...group.querySelectorAll('li')]
            items.forEach(item => {
                item.addEventListener('click', ev => {
                    ev.stopPropagation()
                    const ul = ev.target.closest('ul')
                    if (ev.target.dataset.active === '1') {
                        ev.target.setAttribute('data-active', '0');
                        ev.target.classList.remove('ticked');
                        ul.removeAttribute('aria-activedescendant')
                    } else {
                        items.filter(item => item.dataset.active === '1').forEach(item => {
                            item.dataset.active = 0
                        })
                        ev.target.setAttribute('data-active', '1');
                        ev.target.classList.add('ticked');
                        ul.setAttribute('aria-activedescendant', ev.target.id)
                    }
                    updateFilters()
                })
            })
        })
    
        /**********************
         *        Tags        *
         **********************/
        tagSearch.addEventListener('input', _ => {
            if (tagSearch.value === '') {
                 tagWrap.classList.add('d-none')
            } else {
                const tags = [...tagWrap.querySelectorAll('li')]
                tags.forEach(tag => tag.classList.add('d-none'))
                const filteredTags = tags
                    .filter(tag => !tag.classList.contains('active'))
                    .filter(tag => tag.innerText.toLowerCase().includes(tagSearch.value.toLowerCase()))
                if (filteredTags.length) {
                    tagWrap.classList.remove('d-none')
                    filteredTags.forEach(tag => tag.classList.remove('d-none'))
                } else {
                    tagWrap.classList.add('d-none')
                }
            }
        })
        tagWrap.querySelectorAll('li').forEach(tag => {
            tag.addEventListener('click', _ => {
                const span = document.createElement('span')
                span.classList.add('bg-primary', 'text-white', 'p-2', 'text-sm', 'active-tag', 'rounded-lg', 'overflow-hidden')
                span.appendChild(document.createTextNode(tag.innerText))
                span.dataset.value = tag.dataset.value
                const btn = document.createElement('span')
                btn.classList.add('ml-2', 'cursor-pointer')
                btn.appendChild(document.createTextNode('\u00d7'))
                btn.addEventListener('click', _ => {
                    activeTags.removeChild(span)
                    // if (activeTags.children.length === 0) {
                    //     activeTags.classList.replace('ml-4', 'ml-0')
                    // }
                    tag.classList.remove('active')
                    updateFilters()
                })
                span.appendChild(btn)
                activeTags.appendChild(span)
                // activeTags.classList.replace('ml-0', 'ml-4')
                tag.classList.add('d-none', 'active')
                tagSearch.value = ''
                tagWrap.classList.add('d-none')
                updateFilters()
            })
        })
    
        /**********************
         *       Search       *
         **********************/
        if (searchField) {
            searchField.addEventListener('input', _ => {
                if (searchDelay) {
                    clearTimeout(searchDelay)
                }
                searchDelay = setTimeout(_ => {
                    if (searchField.value !== searchField.dataset.searched) {
                        searchField.dataset.searched = searchField.value
                        searchLoading.classList.remove('d-none')
                        fetch('/search', {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                                'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content,
                            },
                            body: JSON.stringify({ query: searchField.value }),
                        })
                            .catch(err => {
                                console.warn(err)
                            })
                            .then(res => res.json())
                            .then(json => {
                                searchedPosts.splice(0)
                                searchedPosts.push(...json)
                                searchLoading.classList.add('d-none')
                                updateFilters()
                            })
                            .catch(err => {
                                console.warn(err)
                            })
                    }
                }, 5e2)
            })
        }
    
        /**********************
         *   Clear Filters    *
         **********************/
        clearFiltersButton.addEventListener('click', _ => {
            clearFilters()
        });
    
        
    });
}

export { researchBriefs };